export default __webpack_public_path__ + "56912cf37a04dae0ec1da984ac7a82a1.svg";